// ===================================================================
// KAIXO - Cliente: corrección ortográfica/gramatical
// ===================================================================
// Cliente axios aislado que llama a /api/correct.
// Lee token y user del localStorage igual que el resto de servicios.
// ===================================================================

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://backend-dlmm.onrender.com/api';

export async function correctText(text, language) {
    const token = localStorage.getItem('kaixo_token');
    const { data } = await axios.post(
        `${API_URL}/correct`,
        { text, language: language || undefined },
        {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
            timeout: 25000
        }
    );
    return data;
}
